// TODO: wrapped in define, all globals prefixed with window. just to match this into require.js

define('legacy/data-TEMP',['.', 'legacy/yui-2.9.0-combo', 'all/player/session', 'all/navigation', 'all/flushcommunicationbar'], function(_, YAHOO, session, navigation, flushcommunicationbar) {
	'use strict';
	var dataTemp = {};

	/***********************************************************************************
	 * TEMPORARY data.js COPY WHILE MAKING UPDATES AND REFACTORINGS OF WHITELABEL STUFF
	 ***********************************************************************************/

	/**
	 * Variable declaration because we need it to be 'global'
	 */
	window.modalPanel = null;

	window.iFocus = '';

	/**
	 * Global variable for Refer A Friend
	 */
	window.pushedTabElement = null;

	/**
	 * Check field, Refer A Friend
	 *
	 * @param input
	 */
	window.checkField = function(input, extended) {
		'use strict';
		var id = $(input).attr('id');
		var $symbol = $('#' + id + '-infosymbol');
		if (validateInputRegexp($(input).val(), extended)) {
			$symbol.removeClass('fieldstatus-error fieldstatus-info');
			$symbol.addClass('fieldstatus-ok');
		} else {
			$symbol.removeClass('fieldstatus-info fieldstatus-ok');
			$symbol.addClass('fieldstatus-error');
		}
	};

	/**
	 * Check email, Refer A Friend
	 *
	 * @param textField
	 */
	window.checkEmail = function(textField) {
		'use strict';
		var id = $(textField).attr('id');
		var $symbol = $('#' + id + '-infosymbol');
		if (validateEmailRegexp($(textField).val())) {
			$symbol.removeClass('fieldstatus-error fieldstatus-info');
			$symbol.addClass('fieldstatus-ok');
		} else {
			$symbol.removeClass('fieldstatus-info fieldstatus-ok');
			$symbol.addClass('fieldstatus-error');
		}
	};

	/**
	 * Validate email with a regexp
	 *
	 * @param email
	 * @returns true if valid email
	 */
	window.validateEmailRegexp = function(email) {
		var regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regexp.test(email);
	};

	/**
	 * Validate the input
	 *
	 * @param input
	 * @returns true or false
	 */
	window.validateInputRegexp = function(input, extended) {
		var regexp;
		if (extended) {
			regexp = /.+/;
		} else {
			regexp = /^[A-Za-z åöäÅÖÄ-]{2,20}$/;
		}
		return regexp.test(input);
	};

	/**
	 * Check fields for Refer A Friend
	 */
	window.checkFields = function() {
		var returnValue = true;
		if (!validateInputRegexp($('#PARAM_FIRST_NAME').val())) {
			$('#PARAM_FIRST_NAME-infosymbol').removeClass('fieldstatus-info fieldstatus-ok');
			$('#PARAM_FIRST_NAME-infosymbol').addClass('fieldstatus-error');
			returnValue = false;
		}
		if (!validateInputRegexp($('#PARAM_SURNAME').val())) {
			$('#PARAM_SURNAME-infosymbol').removeClass('fieldstatus-info fieldstatus-ok');
			$('#PARAM_SURNAME-infosymbol').addClass('fieldstatus-error');
			returnValue = false;
		}
		if (!validateEmailRegexp($('#PARAM_EMAIL').val())) {
			$('#PARAM_EMAIL-infosymbol').removeClass('fieldstatus-info fieldstatus-ok');
			$('#PARAM_EMAIL-infosymbol').addClass('fieldstatus-error');
			returnValue = false;
		}
		if (!validateInputRegexp($('#PARAM_SUBJECT').val(), true)) {
			$('#PARAM_SUBJECT-infosymbol').removeClass('fieldstatus-info fieldstatus-ok');
			$('#PARAM_SUBJECT-infosymbol').addClass('fieldstatus-error');
			returnValue = false;
		}
		if (!validateInputRegexp($('#PARAM_COMMENT').val(), true)) {
			$('#PARAM_COMMENT-infosymbol').removeClass('fieldstatus-info fieldstatus-ok');
			$('#PARAM_COMMENT-infosymbol').addClass('fieldstatus-error');
			returnValue = false;
		}
		return returnValue;
	};

	window.showMailSentPopup = function() {
		$('#raf-form').hide();

		$('#raf-loading').show();
		setTimeout(function() {
			$('#raf-loading').hide();
			$('#raf-loaded').show();
		}, 2000);
	};

	window.showSymbol = function(inParamName, inClass) {
		var infosymbol = new YAHOO.util.Element(inParamName + '-infosymbol');
		if (infosymbol.hasClass('fieldstatus-info')) {
			infosymbol.replaceClass('fieldstatus-info', inClass);
		} else if (infosymbol.hasClass('fieldstatus-error')) {
			infosymbol.replaceClass('fieldstatus-error', inClass);
		} else {
			infosymbol.replaceClass('fieldstatus-ok', inClass);
		}
	};

	window.showBox = function(o) {
		var paramName;
		var infosymbol = new YAHOO.util.Element(o);
		if (infosymbol.hasClass('fieldstatus-info')) {
			paramName = o.replace('-infosymbol', '');
			var info = new YAHOO.util.Element(paramName + '-info');
			info.setStyle('display', 'block');
		} else if (infosymbol.hasClass('fieldstatus-error')) {
			paramName = o.replace('-infosymbol', '');
			var error = new YAHOO.util.Element(paramName + '-error');
			error.setStyle('display', 'block');
		}
	};

	window.hideBox = function(o) {
		var paramName;
		var infosymbol = new YAHOO.util.Element(o);
		if (infosymbol.hasClass('fieldstatus-info')) {
			paramName = o.replace('-infosymbol', '');
			var info = new YAHOO.util.Element(paramName + '-info');
			info.setStyle('display', 'none');
		} else if (infosymbol.hasClass('fieldstatus-error')) {
			paramName = o.replace('-infosymbol', '');
			var error = new YAHOO.util.Element(paramName + '-error');
			error.setStyle('display', 'none');
		}
	};

	// TODO: this is old crap used by temporary registerForm etc, switch to new popup system instead
	window.focusCallback = function(el) {

		var $el = $(el);
		var $parent = $el.parentsUntil('form');
		var id = '#' + $el.attr('id');

		var $info = $parent.find(id + '-infosymbol');
		if ($info.hasClass('fieldstatus-info')) {
			$parent.find(id + '-info').show();
		}

		var $error = $parent.find(id + '-infosymbol');
		if ($error.hasClass('fieldstatus-error')) {
			$parent.find(id + '-info').show();
		}
	};

	// TODO: this is old crap used by temporary registerForm etc, switch to new popup system instead
	// TODO: data is set on the symbol for some stupid reason
	window.showMessage = function(el) {

		$('.speech-bubble-info,.speech-bubble-info-down').hide();
		$('.speech-bubble-error,.speech-bubble-error-down').hide();

		// backwards compatibility with stuff like default.js that might sneakily call us the old way
		if ($.type(el) === 'string' && /^[^#]/.test(el)) {
			el = '#' + el;
		}

		var $el = $(el);

		if ($el.length > 1) {
			console.warn('data-TEMP.js', 'showMessage called with invalid object:', el);
			return;
		}

		var $parent = $el.parentsUntil('form');
		var id = '#' + $el.attr('id').replace('-infosymbol', '');

		if ($el.hasClass('fieldstatus-info')) {
			$parent.find(id + '-info').show();
		}

		if ($el.hasClass('fieldstatus-error')) {
			$parent.find(id + '-error').show();
		}
	};

	window.hideMessage = function() {
		$('.speech-bubble-info,.speech-bubble-info-down').hide();
		$('.speech-bubble-error,.speech-bubble-error-down').hide();
	};

	// Bonus and Lottery Bonus
	window.valCalc = function(o) {
		// Validate the amount and calculate the bonus

		// replace all non numbers with blanks except .
		var node;
		var parentNode;
		var max = Number((document.getElementById('b_e_f_max').innerHTML).replace(",", ".").replace(/[^\.\d]/g, ''));
		var min = Number((document.getElementById('b_e_f_min').innerHTML).replace(",", ".").replace(/[^\.\d]/g, ''));
		var prc = Number(document.getElementById('b_e_f_prc').innerHTML);
		var currCode = document.getElementById('currency-code').innerHTML;

		var bal = Number((document.getElementById('b_e_f_free_bal').innerHTML).replace(/\s/g, '').replace(",", ".").replace(/[^\.\d]/g, ''));
		var amount = Number(o.value.replace(",", "."));

		var bonus = amount * (prc / 100);
		var tot = amount + bonus;

		// Validate amount
		if (isNaN(amount) || amount == 0) {
			showSymbol(o.id, 'fieldstatus-error');
			document.getElementById('b_e_f_bonus').innerHTML = '';
			document.getElementById('b_e_f_total').innerHTML = '';
		} else if (!amount || amount === '') {
			showSymbol(o.id, 'fieldstatus-info');
			parentNode = document.getElementById('PARAM_AMOUNT-error-exis-funds-info');
			node = document.getElementById('amount-bonus-not-valid-exis-funds-info');
			parentNode.innerHTML = node.innerHTML;
			document.getElementById('b_e_f_bonus').innerHTML = '';
			document.getElementById('b_e_f_total').innerHTML = '';
		} else if (amount > bal) {
			showSymbol(o.id, 'fieldstatus-error');
			parentNode = document.getElementById('PARAM_AMOUNT-error-exis-funds');
			node = document.getElementById('amount-bonus-not-valid-exis-funds-info-error');
			parentNode.innerHTML = node.innerHTML;
			document.getElementById('b_e_f_bonus').innerHTML = '';
			document.getElementById('b_e_f_total').innerHTML = '';
		} else if (amount > max) {
			showSymbol(o.id, 'fieldstatus-error');
			parentNode = document.getElementById('PARAM_AMOUNT-error-exis-funds');
			node = document.getElementById('amount-bonus-not-valid-exis-funds-error');
			document.getElementById('b_e_f_bonus').innerHTML = '';
			document.getElementById('b_e_f_total').innerHTML = '';
		} else if (amount < min) {
			showSymbol(o.id, 'fieldstatus-error');
			parentNode = document.getElementById('PARAM_AMOUNT-error-exis-funds');
			node = document.getElementById('amount-bonus-not-valid-exis-funds-error');
			parentNode.innerHTML = node.innerHTML;
			document.getElementById('b_e_f_bonus').innerHTML = '';
			document.getElementById('b_e_f_total').innerHTML = '';
		} else {
			showSymbol(o.id, 'fieldstatus-ok');
			document.getElementById('b_e_f_bonus').innerHTML = bonus.toFixed(2).replace(".", ",") + " " + currCode;
			document.getElementById('b_e_f_total').innerHTML = tot.toFixed(2).replace(".", ",") + " " + currCode;
		}
	};

	// Validate buy amount and submit modal function if ok
	window.submitBonusBuy = function() {
		var infosymbol = new YAHOO.util.Element('PARAM_AMOUNT-infosymbol');
		if (infosymbol.hasClass('fieldstatus-error')) {
			return false;
		}
		submitModalFunction();
	};

	window.showModalPanel = function(inHeader, inBody, successReloadPage, inWidth, successReloadTarget, inClose, inFixedCenter) {
		if (modalPanel) {
			modalPanel.destroy();
			modalPanel = null;
		}

		var _width = '400px';
		if (inWidth) {
			_width = inWidth;
		}
		var _fixedcenter = false;
		if (inFixedCenter) {
			_fixedcenter = inFixedCenter;
		}
		if (!_fixedcenter) {
			scrollTo(0, 0);
		}

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            _fixedcenter = false;
            scrollTo(0, 0);
        }

		var _close = inClose ? inClose : true;
		// Initialize the temporary Panel to display while waiting for external
		// content to load
		modalPanel = new YAHOO.widget.Panel('modalPanel', {
			width: _width,
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			zindex: 9204,
			modal: true,
			fixedcenter: _fixedcenter,
			visible: false
		});
		modalPanel.setHeader(inHeader);
		modalPanel.setBody(inBody);
		modalPanel.render(document.body);
		modalPanel.show();
		if (successReloadPage) {
			modalPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			modalPanel.successReloadTarget = successReloadTarget;
		}
	};

	window.waitForIt = [];
	window.submitModalFunction = function(onSuccess, scp) {
		try {
			if (scp) {
				if (waitForIt[scp]) {
					return;
				}
				waitForIt[scp] = true;
			}
		} catch (e) {
		}

		var el = new YAHOO.util.Element(modalPanel.body);

		var formObject = el.getElementsByTagName('form')[0];
		var formAction = el.getElementsByTagName('form')[0].getAttribute('action');
		YAHOO.util.Connect.setForm(formObject);
		var mbs = new ModalResponseSuccess(onSuccess, formObject.name, scp, true);
		var modalCallback = {
			success: mbs.successHandler,
			failure: mbs.failureHandler,
			scope: mbs,
			cache: false
		};

		YAHOO.util.Connect.initHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
		YAHOO.util.Connect.asyncRequest('POST', formAction, modalCallback);
	};

	window.submitModalFunction = function(onSuccess, scp, hidePanel) {
		if (hidePanel === undefined) {
			hidePanel = true;
		}

		try {
			if (scp) {
				if (waitForIt[scp]) {
					return;
				}
				waitForIt[scp] = true;
			}
		} catch (e) {
		}

		var el = new YAHOO.util.Element(modalPanel.body);

		var formObject = el.getElementsByTagName('form')[0];
		var formAction = el.getElementsByTagName('form')[0].getAttribute('action');
		YAHOO.util.Connect.setForm(formObject);

		var mbs = new ModalResponseSuccess(onSuccess, formObject.name, scp, hidePanel);
		var modalCallback = {
			success: mbs.successHandler,
			failure: mbs.failureHandler,
			scope: mbs,
			cache: false
		};

		YAHOO.util.Connect.initHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
		YAHOO.util.Connect.asyncRequest('POST', formAction, modalCallback);
	};

	window.getModalPanelHtml = function(inFlow, inPanelHeader, successReloadPage, width, successReloadTarget, inClose) {

		var mpr = new ModalPanelHtmlResponse(inPanelHeader, successReloadPage, width, successReloadTarget, inClose);
		var modalCallback = {
			success: mpr.successHandler,
			failure: mpr.failureHandler,
			scope: mpr,
			cache: false
		};

		YAHOO.util.Connect.asyncRequest('POST', "/pp?", modalCallback, 'flow=' + inFlow);
	};
	window.ModalPanelHtmlResponse = function(inPanelHeader, successReloadPage, width, successReloadTarget, inClose) {
		if (inPanelHeader) {
			this.panelHeader = inPanelHeader;
		} else {
			this.panelHeader = '';
		}
		this.failureHandler = function(o) {
			showSystemError('System error', 'An unexpected system error occured', 'OK');
		};
		this.successHandler = function(o) {

			try {
				window.top.showModalPanel(this.panelHeader, o.responseText, successReloadPage, width, successReloadTarget, inClose, true);
			} catch (e) {
				modalPanel.hide();
				showSystemError('System error', 'An unexpected system error occured (genericResponseSuccess)', 'OK');
			}
		};
	};

	window.showConfirmMessage = function(inHeader, inMessage, inButtonText, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode, inButtonText2, inButtonCode2, icon) {
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			fixedcenter: true,
			zindex: 9205,
			modal: true,
			visible: false
		});

		if (icon == null) {
			icon = navigation.staticURL("/static/img/icon_info-big.gif");
		}
		if (panelHeader) {
			errorPanel.setHeader(panelHeader);
		}
		if (!inButtonCode) {
			inButtonCode = '';
		}

		var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + icon + '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage + '</p></div><ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideGenericPopup();' + inButtonCode + '; return false;"><span>' + inButtonText + '</span></a></li><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideGenericPopup();' + inButtonCode2 + '; return false;"><span>' + inButtonText2 + '</span></a></li></ul></div>';
		errorPanel.setBody(myBody);

		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}
		errorPanel.render(document.body);
		errorPanel.show();
	};

	window.showInfoPopup = function(inHeader, inMessage, inButtonText, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode, icon, content, inMessageExtra, inButtonLink) {
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			fixedcenter: true,
			close: _close,
			draggable: false,
			zindex: 9205,
			modal: true,
			visible: false
		});

		if (panelHeader) {
			errorPanel.setHeader(panelHeader);
		}
		if (!inButtonCode) {
			inButtonCode = '';
		}
		if (!icon) {
			icon = navigation.staticURL("/static/img/icon_info-big.gif");
		}

		if (!content) {
			content = '';
		}

		var inButtonHtml = '';
		if (inButtonLink === '') {
			inButtonHtml = '\n<ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideGenericPopup();' + inButtonCode + '; return false;"><span>' + inButtonText + '</span></a></li></ul></div>';
		} else {
			inButtonHtml = '\n<ul class="pc-buttons"><li><a href=\'' + inButtonLink + '\'onclick="hideGenericPopup()"; class="ui-button size-30 color-primary"><span>' + inButtonText + '</span></a></li></ul></div>';
		}

		var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + icon + '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage + '</p>\n' + inMessageExtra + '</div>\n' + content + inButtonHtml;

		errorPanel.setBody(myBody);
		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}
		errorPanel.render(document.body);
		errorPanel.show();

		$('.container-close').click(function() {
			flushcommunicationbar.flushCommunicationBar();
		});
	};

	window.submitGenericButtonFunction = function(buttonName, args, callBack) {
		var mbs = new GenericResponseSuccess('');
		var modalCallback = {
			success: mbs.successHandler,
			failure: mbs.failureHandler,
			scope: mbs,
			cache: false
		};

		YAHOO.util.Connect.asyncRequest('POST', '/pp?', (callBack == null) ? modalCallback : callBack, 'flow=GenericButton&KjButton=' + buttonName + '&' + args);
	};

	window.GenericResponseSuccess = function() {
		this.failureHandler = function(o) {
			showSystemError('System error', 'An unexpected system error occured', 'OK');
		};
		this.successHandler = function(o) {
			try {
				var formResponse = YAHOO.lang.JSON.parse(o.responseText);
				genericParseResult(formResponse);
			} catch (e) {
				modalPanel.hide();
				showSystemError('System error', 'An unexpected system error occured (genericResponseSuccess)', 'OK');
			}
		};
	};

	window.genericParseResult = function(formResponse) {
		if (formResponse['RESULT'] == 'SYSTEM_ERROR') {
			if (modalPanel) {
				modalPanel.hide();
			}
			showSystemError(formResponse['ERROR_HEADER'], formResponse['ERROR'], formResponse['BUTTON_TEXT']);

		} else if (formResponse['RESULT'] == 'INFO_POPUP' || formResponse['RESULT'] == 'WITHDRAW_ERROR_POPUP') {
			if (modalPanel) {
				modalPanel.hide();
			}
			var starget = (formResponse['SUCCESS_RELOAD_TARGET'] == null) ? null : ((formResponse['SUCCESS_RELOAD_TARGET'] == 'true') ? true
				: formResponse['SUCCESS_RELOAD_TARGET']);
			var spage = (formResponse['SUCCESS_RELOAD_PAGE'] == null) ? null : ((formResponse['SUCCESS_RELOAD_PAGE'] == 'true') ? true
				: formResponse['SUCCESS_RELOAD_PAGE']);
			var inclose = formResponse['IN_CLOSE'];
			var inMessageExtra = '';
			if (formResponse['IN_MESSAGE_EXTRA']) {
				inMessageExtra = formResponse['IN_MESSAGE_EXTRA'];
			}

			var inButtonLink = '';
			if (formResponse['IN_BUTTON_LINK']) {
				inButtonLink = formResponse['IN_BUTTON_LINK'];
			}

			var content = formResponse['POPUP_REST_BODY_CONTENT'];
			showInfoPopup(formResponse['IN_HEADER'], formResponse['IN_MESSAGE'], formResponse['IN_BUTTON_TEXT'], inclose, spage, starget,
				formResponse['PANEL_HEADER'], formResponse['IN_BUTTON_CODE'], formResponse['ICON'], content, inMessageExtra, inButtonLink);

			// just for withdraws
			if (formResponse['INPUT_ERROR'] == 'AMOUNT') {
				try {
					var yf = document.getElementById('bodyframe');
					yf.contentWindow.iFocus = '';
					yf.contentWindow.hideMessage('editamount-infosymbol');
					yf.contentWindow.showSymbol('editamount', 'fieldstatus-error');
				} catch (ex) { // alert (ex);

				}
				;
			}

		} else if (formResponse['RESULT'] == 'CONFIRM_POPUP') {
			if (modalPanel) {
				modalPanel.hide();
			}
			var starget = formResponse['SUCCESS_RELOAD_TARGET'];
			var spage = formResponse['SUCCESS_RELOAD_PAGE'];
			var inclose = formResponse['IN_CLOSE'];

			showConfirmMessage(formResponse['IN_HEADER'], formResponse['IN_MESSAGE'], formResponse['IN_BUTTON_TEXT'], inclose, spage, starget,
				formResponse['PANEL_HEADER'], formResponse['IN_BUTTON_CODE'], formResponse['IN_BUTTON_TEXT2'], formResponse['IN_BUTTON_CODE2'],
				formResponse['ICON']);

		} else {
			return false;
		} // because we couldn't handle it.

		// nevertheless
		top.hideShade();
		return true;
	};

	window.ModalResponseSuccess = function(onSuccess, from, scp, hidePanel) {
		this.scp = scp;
		this.successJS = onSuccess;
		if (from == 'EmailSupport') {
			modalPanel.successReloadPage = null;
		}

		this.failureHandler = function(o) {
			try {
				if (this.scp) {
					waitForIt[scp] = false;
				}
			} catch (e) {
			}
			showSystemError('System error', 'An unexpected system error occured', 'OK');
		};
		this.successHandler = function(o) {
			try {
				if (this.scp) {
					waitForIt[scp] = false;
				}
			} catch (e) {
			}
			try {
				var formResponse = YAHOO.lang.JSON.parse(o.responseText);
				if (formResponse['RESULT'] != 'OK') {
					if (formResponse['RESULT'] == 'SYSTEM_ERROR') {
						modalPanel.hide();
						showSystemError(formResponse['ERROR_HEADER'], formResponse['ERROR'], formResponse['BUTTON_TEXT']);
						return;
					}

					if (formResponse['RESULT'] == 'RG_LIMIT_ERROR') {
						showInfoMessage(formResponse['ERROR_HEADER'], formResponse['ERROR_MESSAGE'], formResponse['BUTTON_TEXT'], true, null, null,
							formResponse['ERROR_PANEL_HEADER']);
						return;
					}

					if (formResponse['RESULT'] == 'WAGER_LIMIT_ERROR') {
						showInfoMessage(formResponse['ERROR_HEADER'], formResponse['ERROR_MESSAGE'], formResponse['BUTTON_TEXT'], true, null, null,
							formResponse['ERROR_PANEL_HEADER']);
						return;
					}

					if (formResponse['CANCEL_BONUS_OPEN_GAME_ROUND'] && formResponse['CANCEL_BONUS_OPEN_GAME_ROUND'] == 'CANCEL_BONUS_OPEN_GAME_ROUND') {
						showInfoMessage(formResponse['ERROR_HEADER'], formResponse['ERROR_MESSAGE'], formResponse['BUTTON_TEXT'], true, null, null,
							formResponse['ERROR_PANEL_HEADER']);
						return;
					}

					var el = new YAHOO.util.Element(modalPanel.body);
					var form = el.getElementsByTagName('form')[0];
					var errorString = "<ul>";
					for (var i = 0; i < form.elements.length; i++) {
						var element = form.elements[i];
						if (formResponse['ERROR_FIELDS'].indexOf(element.name) != -1 && formResponse[element.name]) {
							showSymbol(element.name, 'fieldstatus-error');
							errorString = errorString + "<li>" + formResponse[element.name] + "</li>";
						} else {
							showSymbol(element.name, 'fieldstatus-info');
						}
					}
					errorString = errorString + "<ul/>";
					var sleep;
					if (formResponse['ERROR_PANEL_HEADER']) {
						if (formResponse['SLEEP_IN_MILLI_SECONDS'] !== null) {
							sleep = parseInt(formResponse['SLEEP_IN_MILLI_SECONDS']);
							setTimeout(function() {
								if (formResponse['RESULT'] == 'JSON_NOT_OK_HIDE_PANEL') {
									modalPanel.hide();
								}
								showInfoMessage(formResponse['ERROR_HEADER'], errorString, formResponse['BUTTON_TEXT'], true, null, null,
									formResponse['ERROR_PANEL_HEADER']);
							}, sleep);
						} else {
							showInfoMessage(formResponse['ERROR_HEADER'], errorString, formResponse['BUTTON_TEXT'], true, null, null,
								formResponse['ERROR_PANEL_HEADER']);
						}
					} else {
						var textKeyArray = new Array('HEADER_PANEL_VALIDATION_ERROR');
						var textMap = textkey.getTextValues(textKeyArray);

						if (formResponse['SLEEP_IN_MILLI_SECONDS'] !== null) {
							sleep = parseInt(formResponse['SLEEP_IN_MILLI_SECONDS']);
							setTimeout(function() {
								if (formResponse['RESULT'] == 'JSON_NOT_OK_HIDE_PANEL') {
									modalPanel.hide();
								}
								showInfoMessage(formResponse['ERROR_HEADER'], errorString, formResponse['BUTTON_TEXT'], true, null, null,
									textMap.HEADER_PANEL_VALIDATION_ERROR);
							}, sleep);
						} else {
							showInfoMessage(formResponse['ERROR_HEADER'], errorString, formResponse['BUTTON_TEXT'], true, null, null,
								textMap.HEADER_PANEL_VALIDATION_ERROR);
						}
					}
				} else {
					// Everything went all right
					if (hidePanel) {
						modalPanel.hide();
					}

					if (formResponse['TEXT']) {
						if (modalPanel.successReloadPage || modalPanel.successReloadTarget && from == null) {
							showInfoMessage(formResponse['HEADER'], formResponse['TEXT'], formResponse['BUTTON_TEXT'], false, modalPanel.successReloadPage,
								modalPanel.successReloadTarget, window.top.panelHeaderResponseSuccess, this.successJS);
						} else {
							showInfoMessage(formResponse['HEADER'], formResponse['TEXT'], formResponse['BUTTON_TEXT'], null, null, null,
								window.top.panelHeaderResponseSuccess, this.successJS);
						}
					} else if (formResponse['LOGOUT']) {

						// logout player without a popup login
						if (formResponse['RESP_GAMING']) {
							window.top.showInfoMessage(formResponse['RESP_GAMING_SUBHEADER'], formResponse['RESP_GAMING_MESSAGE'], formResponse['BUTTON_TEXT'],
								false, null, null, formResponse['RESP_GAMING_HEADER']);
						} else {
							window.top.showInfoMessage(headerLogoutPopUp, logoutConfirmation, formResponse['BUTTON_TEXT'], false, null, null, headerLogoutPopUp);
						}

						setTimeout(navigation.gotoLastProductPage, 3000);
						return;
					} else if (modalPanel.successReloadPage) {
						// Reload the calling page
						// modalPanel.successReloadPage.reload();
					} else if (modalPanel.successReloadTarget) {
						try {
							loadUrl(null, modalPanel.successReloadTarget);
						} catch (e) {
							// do nothing
						}

					}

					if (modalPanel.successReloadTarget) {
						try {
							loadUrl(null, modalPanel.successReloadTarget);
						} catch (e) {
							// do nothing
						}
					}

					if (hidePanel) {
						modalPanel.destroy();
						modalPanel = null;
					}
				}
			} catch (e) {
				modalPanel.hide();
				console.log(e);
				showSystemError('System error', 'An unexpected system error occured (js)', 'OK');
			}
		};
	};

	window.errorPanel = null;
	window.showSystemError = function(inHeader, inMessage, inButtonText) {
		scrollTo(0, 0);
		// Initialize the temporary Panel to display while waiting for external
		// content to load
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: true,
			draggable: false,
			zindex: 9205,
			modal: true,
			visible: false
		});
		errorPanel.setHeader(inHeader);
		var myBody;

		if (inMessage == null) {
			myBody = '<div class="popup-container" id="pop-up-width400"><h3>'
				+ inHeader
				+ '</h3><img src="'
				+ navigation.staticURL('img/icon_error.gif')
				+ '" width="80" height="80" border="0" alt=""><div class="bread"><p></p></div><ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="window.top.hideSystemError(); return false;"><span>'
				+ inButtonText + '</span></a></li></ul></div>';
		} else {
			myBody = '<div class="popup-container" id="pop-up-width400"><h3>'
				+ inHeader
				+ '</h3><img src="'
				+ navigation.staticURL('img/icon_error.gif')
				+ '" width="80" height="80" border="0" alt=""><div class="bread"><p>'
				+ inMessage
				+ '</p></div><ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="window.top.hideSystemError(); return false;"><span>'
				+ inButtonText + '</span></a></li></ul></div>';
		}

		errorPanel.setBody(myBody);

		errorPanel.render(document.body);
		errorPanel.show();
	};

	/**
	 * Error popup with close option
	 */
	window.showSystemErrorCustomized = function(inHeader, inMessage, inFirstButtonText, inSecondButtonText, width, closeFlg, draggableFlg, modalFlg, visibleFlg) {
		scrollTo(0, 0);
		// Initialize the temporary Panel to display while waiting for external
		// content to load
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: width,
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: closeFlg,
            fixedcenter: true,
			draggable: draggableFlg,
			zindex: 9205,
			modal: modalFlg,
			visible: visibleFlg
		});
		errorPanel.setHeader(inHeader);

		if (inMessage == null) {
			var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + navigation.staticURL('img/icon_error.gif')
				+ '" width="80" height="80" border="0" alt=""><div class="bread"><p></p></div><ul class="pc-buttons"><li><a href="' + myPagesUserProfile
				+ '" class="ui-button size-30 color-primary" onclick="hideFormError();"><span>' + inFirstButtonText
				+ '</span></a><br/><a href="/" class="ui-button size-30 color-primary"><span>' + inSecondButtonText + '</span></a></li></ul></div>';
		} else {
			var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="'
				+ navigation.staticURL('img/icon_error.gif') + '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage
				+ '</p></div><ul class="pc-buttons"><li><a href="' + myPagesUserProfile
				+ '" class="ui-button size-30 color-primary" onclick="hideFormError();"><span>' + inFirstButtonText
				+ '</span></a><br/><a href="/" class="ui-button size-30 color-primary"><span>' + inSecondButtonText + '</span></a></li></ul></div>';
		}

		errorPanel.setBody(myBody);

		errorPanel.render(document.body);
		errorPanel.show();
	};

	window.hideSystemError = function() {
		// Initialize the temporary Panel to display while waiting for external
		// content to load
		if (errorPanel) {
			errorPanel.hide();
			errorPanel.destroy();
			errorPanel = null;
		}
		window.top.location = '/';
	};

	window.showInfoMessage = function(inHeader, inMessage, inButtonText, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode, icon) {

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			window.top.scrollTo(0, 0);
		}
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			fixedcenter: true,
			zindex: 9205,
			modal: true,
			visible: false
		});

		errorPanel.setHeader(panelHeader ? panelHeader : '&nbsp;');

		if (inButtonCode == null || inButtonCode === null) {
			inButtonCode = '';
		}

		if (icon == null) {
			icon = navigation.staticURL("img/icon_info-big.gif");
		}

		var myBody = '<div class="popup-container clearfix" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + icon
			+ '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage
			+ '</p></div><ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideFormError();' + inButtonCode
			+ '; return false;"><span>' + inButtonText + '</span></a></li></ul></div>';
		errorPanel.setBody(myBody);

		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}

		errorPanel.render(document.body);
		errorPanel.show();
	};

	// generic info popup, pass body as input parameter
	window.showInfoMessageGeneric = function(inBody, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode) {
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			fixedcenter: true,
			zindex: 9205,
			modal: true,
			visible: false
		});
		if (panelHeader) {
			errorPanel.setHeader(panelHeader);
		}

		errorPanel.setBody(inBody);

		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}

		errorPanel.render(document.body);
		errorPanel.show();
	};

	// popup in case that email and/or mobile phone are not verified (calle dfrom
	// bonus, deposit, shop pages)
	window.showEmailMobileVerificationError = function(inHeader, inMessage, inFirstButtonText, inSecondButtonText, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode, icon) {
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			fixedcenter: true,
			zindex: 9205,
			modal: true,
			visible: false
		});
		if (panelHeader) {
			errorPanel.setHeader(panelHeader);
		}
		if (inButtonCode == null || inButtonCode === null) {
			inButtonCode = '';
		}
		if (icon == null) {
			icon = navigation.staticURL("img/icon_info-big.gif");
		}

		var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + icon
			+ '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage + '</p></div><ul class="pc-buttons"><li><a href="'
			+ myPagesUserProfile + '" class="ui-button size-30 color-primary" onclick="hideDepositAndErrorForm();"><span>' + inFirstButtonText
			+ '</span></a><br/><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideFormError();' + inButtonCode
			+ '; return false;"><span>' + inSecondButtonText + '</span></a></li></ul></div>';
		errorPanel.setBody(myBody);

		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}

		errorPanel.render(document.body);
		errorPanel.show();
	};

	// same functionality as showInfoMessage except new knowledge link is added
	window.showInfoMessageKb = function(bonusSystemInfo, bonusSystemInfoKbLink, inHeader, inMessage, inButtonText, inClose, successReloadPage, successReloadTarget, panelHeader, inButtonCode, icon) {
		var _close = inClose ? inClose : true;
		if (errorPanel) {
			errorPanel.destroy();
			errorPanel = null;
		}
		errorPanel = new YAHOO.widget.Panel('errorPanel', {
			width: '400px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: _close,
			draggable: false,
			fixedcenter: true,
			zindex: 9205,
			modal: true,
			visible: false
		});
		if (panelHeader) {
			errorPanel.setHeader(panelHeader);
		}
		if (inButtonCode == null || inButtonCode === null) {
			inButtonCode = '';
		}
		if (icon == null) {
			icon = navigation.staticURL("img/icon_info-big.gif");
		}

		var myBody = '<div class="popup-container" id="pop-up-width400"><h3>' + inHeader + '</h3><img src="' + icon
			+ '" width="80" height="80" border="0" alt=""><div class="bread"><p>' + inMessage
			+ '</p></div><ul class="pc-buttons"><li><a href="javascript:" class="ui-button size-30 color-primary" onclick="hideFormError();' + inButtonCode
			+ '; return false;"><span>' + inButtonText + '</span></a></li>' + '<li><a href="javascript:" onclick="window.top.open(' + '\''
			+ bonusSystemInfoKbLink + '\''
			+ ',\'knowledgebase\',\'width=700,height=500,scrollbars=yes,resizable=yes\');return false;" class="ui-button size-30 color-primary"><span>'
			+ bonusSystemInfo + '</span></a></li></ul></div>';

		errorPanel.setBody(myBody);

		if (successReloadPage) {
			errorPanel.successReloadPage = successReloadPage;
		}
		if (successReloadTarget) {
			errorPanel.successReloadTarget = successReloadTarget;
		}

		errorPanel.render(document.body);
		errorPanel.show();
	};

	window.pushInfoPanel = null;

	// TODO: new simpler version of function, but needs more work, called from PlayerInfo.swf
	window.showPushInfoMessage = function(panelHeader, inHeader, inMessage) {

		if (panelHeader == 'COMMUNICATION_BAR_HEADER') {
			if (CommunicationBar) {
				CommunicationBar.displayMessage('communication', inMessage);
			}
		} else {
			var data = {
				title: panelHeader,
				heading: inHeader,
				message: inMessage
			};

			var content;
			var buttonLink;
			try {
				content = $.parseJSON(decodeURIComponent(inMessage.replace(/\+/g, " ")));
				data.icon = content.ICON;
				data.message = content['IN_MESSAGE'];
				data.extra = content['IN_MESSAGE_EXTRA'];
				data.body = content['POPUP_REST_BODY_CONTENT'];
				buttonLink = content['IN_BUTTON_LINK'];
			} catch (e) {
				console.log('Not JSON (normal):', inMessage);
			}

			var goToUrlOnClose = null;
			if (buttonLink) {
				goToUrlOnClose = function() {
					top.location.href = buttonLink;
				};
			}
            dialog.hideLoader();
			dialog.load('push', data, null, goToUrlOnClose);
		}
	};

	window.hidePushInfo = function() {
		if (pushInfoPanel) {
			pushInfoPanel.hide();
			pushInfoPanel.destroy();
			pushInfoPanel = null;
		}
		flushcommunicationbar.flushCommunicationBar();
		return false;
	};

	window.hideFormError = function() {
		if (errorPanel) {
			if (errorPanel.successReloadPage && window.top.location == errorPanel.successReloadPage) {
				errorPanel.successReloadPage.reload();
			} else if (errorPanel.successReloadPage && errorPanel.successReloadTarget == null) {
				window.top.location.href = errorPanel.successReloadPage;
			} else if (errorPanel.successReloadTarget) {
				loadUrl(errorPanel.successReloadPage, errorPanel.successReloadTarget);
			}

			errorPanel.hide();
			errorPanel.destroy();
			errorPanel = null;
		}
		return false;
	};

	/**
	 * Will try to hide the error popup first and the deposit popup afterwards.
	 */
	window.hideDepositAndErrorForm = function() {
		hideFormError();
		if (easyDepPanel !== null) {
			easyDepPanel.hide();
			easyDepPanel.destroy();
			easyDepPanel = null;
		}
		return false;
	};

	window.hideGenericPopup = function() {
		errorPanel.hide();

		flushcommunicationbar.flushCommunicationBar();
		if (errorPanel) {
			if (errorPanel.successReloadPage === true) {
				window.top.location.href = errorPanel.successReloadPage;
				errorPanel.destroy();
				errorPanel = null;
				return;
			}

			if (errorPanel.successReloadPage && window.top.location == errorPanel.successReloadPage) {
				errorPanel.successReloadPage.reload();
			} else if (errorPanel.successReloadPage && errorPanel.successReloadTarget == null) {
				window.top.location.href = errorPanel.successReloadPage;
			} else if (errorPanel.successReloadTarget) {
				loadUrl(errorPanel.successReloadPage, errorPanel.successReloadTarget);
			}
		}
		return false;
	};

	window.reloadPageForIE = function() {
		if (navigator.appName.indexOf('Microsoft') != -1) {
			location.reload(true);
		}
	};

	window.showCBPanel = function(inHeader, inBody, inOverideConfirmationHtml) {

		if (modalPanel) {
			modalPanel.destroy();
			modalPanel = null;
		}
		// Initialize the temporary Panel to display while waiting for external
		// content to load
		modalPanel = new YAHOO.widget.Panel('modalPanel', {
			width: '500px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: true,
			draggable: false,
			zindex: 9204,
			modal: true,
			fixedcenter: true,
			visible: false
		});
		modalPanel.setHeader(inHeader);
		modalPanel.setBody(inBody);
		modalPanel.render(document.body);
		modalPanel.show();
		modalPanel.och = inOverideConfirmationHtml;
	};

	window.CancelBonusResponse = function(inOverideConfirmationHtml) {
		this.och = inOverideConfirmationHtml;
		this.failureHandler = function(o) {
			showSystemError('System error', 'An unexpected system error occured (764)', 'OK');
		};
		this.successHandler = function(o) {
			// Parsing JSON strings can throw a SyntaxError exception, so we wrap
			// the call
			// in a try catch block
			try {
				var formResponse = YAHOO.lang.JSON.parse(o.responseText);
				if (formResponse['RESULT'] != 'OK') {
					if (formResponse['RESULT'] == 'SYSTEM_ERROR') {
						modalPanel.hide();
						modalPanel.destroy();
						modalPanel = null;
						showSystemError(formResponse['ERROR_HEADER'], formResponse['ERROR'], formResponse['BUTTON_TEXT']);
						return;
					}
					if (formResponse['CANCEL_BONUS_OPEN_GAME_ROUND'] && formResponse['CANCEL_BONUS_OPEN_GAME_ROUND'] == 'CANCEL_BONUS_OPEN_GAME_ROUND') {
						// Special handling
						var pHeader = modalPanel.header.innerHTML;
						var str = this.och.replace('replace me', formResponse['ERROR']);
						modalPanel.hide();
						modalPanel.destroy();
						modalPanel = null;
						window.top.showModalPanel(pHeader, str, null, '500px', 'bodyframe', true, true);
						return;
					}
				} else {
					// Everything went all right
					modalPanel.hide();
					modalPanel.destroy();
					modalPanel = null;
					showInfoMessage(formResponse['HEADER'], formResponse['TEXT'], formResponse['BUTTON_TEXT'], false, null, 'bodyframe',
						window.top.panelHeaderResponseSuccess, null);
					try {
						loadUrl(null, 'bodyframe');

					} catch (e) {
						// do nothing
					}
				}

			} catch (e) {
				modalPanel.hide();
				modalPanel.destroy();
				modalPanel = null;
				showSystemError('System error', 'An unexpected system error occured (js)\n' + e, 'OK');
			}
		};
	};
	window.submitCancelBonus = function() {
		var el = new YAHOO.util.Element(modalPanel.body);

		var formObject = el.getElementsByTagName('form')[0];
		var formAction = el.getElementsByTagName('form')[0].getAttribute('action');
		var formdata = YAHOO.util.Connect.setForm(formObject);
		var cbr = new CancelBonusResponse(modalPanel.och);
		var modalCallback = {
			success: cbr.successHandler,
			failure: cbr.failureHandler,
			scope: cbr,
			cache: false
		};
		YAHOO.util.Connect.initHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
		var transaction = YAHOO.util.Connect.asyncRequest('POST', formAction, modalCallback);
	};
	window.okCancelPanel = null;
	window.showOkCancelPanel = function(inPanelHeader, inBody, inOkCancelHandler) {
		if (okCancelPanel) {
			okCancelPanel.destroy();
			okCancelPanel = null;
		}
		okCancelPanel = new YAHOO.widget.Panel('okCancelPanel', {
			width: '450px',
			context: [ 'popup-positioner-400', 'tl', 'tl' ],
			close: false,
			draggable: false,
			fixedcenter: true,
			zindex: 9206,
			modal: true,
			visible: false
		});
		okCancelPanel.setHeader(inPanelHeader);
		okCancelPanel.okcancelHandler = inOkCancelHandler;
		okCancelPanel.setBody(inBody);
		okCancelPanel.render(document.body);
		okCancelPanel.show();
	};
	window.handleOkOkCancel = function() {
		okCancelPanel.okcancelHandler.ok();
		hideOkCancelPanel();
		return false;
	};
	window.handleCancelOkCancel = function() {
		okCancelPanel.okcancelHandler.cancel();
		hideOkCancelPanel();
		return false;
	};
	window.hideOkCancelPanel = function() {
		okCancelPanel.hide();
		okCancelPanel.destroy();
		okCancelPanel = null;
		// alert("hide me");
	};

	// used for a bonus popup on checkbonus reminder
	window.setACookieFromDepositCheckBox = function(o) {
		var isChecked = o.checked;

		var exdate = new Date();
		exdate.setDate(exdate.getDate() + 365);
		var c_value = escape(isChecked) + ((365 == null) ? '' : "; expires=" + exdate.toUTCString());
		document.cookie = o.name + "=" + c_value + "; path=/";

		return true;
	};

	window.setCookie = function(c_name, value, exdays) {
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value = escape(value) + ((exdays == null) ? '' : "; expires=" + exdate.toUTCString());
		document.cookie = c_name + "=" + c_value;
	};

	// open account status (account succesfully opened or not)
	window.openEarlyAccountJSON = {
		success: function(o) {

			var params = YAHOO.lang.JSON.parse(o.responseText);

			showInfoMessage(params.RESPONSE_HEADER, params.RESPONSE_MESSAGE, params.RESPONSE_BUTTON, true, null, null, params.RESPONSE_POPUP_HEADER);

		},
		failure: function(o) {
		},
		cache: false,
		timeout: 5000
	};

	// open account status (account succesfully opened or not)
	window.openAccountJSON = {
		success: function(o) {
			var params = YAHOO.lang.JSON.parse(o.responseText);
			showInfoMessage(params.RESPONSE_HEADER, params.RESPONSE_MESSAGE, params.RESPONSE_BUTTON, true, null, null, params.RESPONSE_POPUP_HEADER);
		},
		failure: function(o) {
		},
		cache: false,
		timeout: 5000
	};

	// player reopens an account if account is closed on his request
	window.reopenAccount = function(url, username) {
		YAHOO.util.Connect.asyncRequest('POST', url, openAccountJSON, 'flow=updatePlayerStatus' + '&username=' + username);
	};

	// player requested an early reopening. The account will be opened exactly 7
	// days later.
	window.earlyReopenAccount = function(url, username) {
		YAHOO.util.Connect.asyncRequest('POST', url, openEarlyAccountJSON, 'flow=updatePlayerSuspendTime' + '&username=' + username);
	};

	return dataTemp;
});

